import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '../../../common/buttons';
import Checkbox from '../../../common/buttons/Checkbox';
import { Heading, Icon } from '../../../common/layout';
import { DialogModal } from '../../../common/modal';
import {
  setMapType,
  getMapType,
  toggleTileLayer,
} from '../../../interface/';
import { isDefaultVisibleOverlay, isTileOverlay } from '../../../../utils/overlays';
import './Overlays.scss';

const defaultStyle = 'streets';
const satelliteStyle = 'satellite';

const Overlays = () => {
  const [overlayState, setOverlayState] = useState({});
  const [currentStyle, setCurrentStyle] = useState(
    getMapType() === 'satellite' ? satelliteStyle : defaultStyle
  );
  const { overlays, config } = useSelector((state) => state);
  const [showOverlays, setShowOverlays] = useState(false);
  const tileOverlays = overlays.filter(isTileOverlay);
  const hasOverlays = tileOverlays.length > 0;

  useEffect(() => {
    if (tileOverlays.length > 0) {
      const overlayState = tileOverlays.reduce((initState, overlay) => {
        initState[overlay.id] = isDefaultVisibleOverlay(overlay);
        return initState;
      }, {});
      setOverlayState(overlayState);
    }
  }, [overlays]);

  const setMapStyle = ({ target }) => {
    if (target.name === satelliteStyle) {
      setMapType('satellite');
    } else {
      setMapType('roadmap');
    }
    setCurrentStyle(target.name);
  };

  const handleLayerToggle = (id) => {
    const visible = toggleTileLayer(id);
    setOverlayState({ ...overlayState, [id]: visible });
  };

  const renderOverlayOptions = () =>
    tileOverlays.map((overlay) => (
      <li key={overlay.id} className="map-controls__overlay-toggle">
        <Checkbox
          handleChange={() => handleLayerToggle(overlay.id)}
          checked={overlayState[overlay.id]}
        />
        {overlay.url}
      </li>
    ));

  const satActive = currentStyle === satelliteStyle;

  return (
    <div className="map-controls__overlays-btn-wrapper">
      <Button
        className="map-controls__map-layer-btn map-btn"
        handleClick={() => setShowOverlays(!showOverlays)}
        aria-label="Swap Map Layers"
        toolTipId="swap-map-layer-btn"
        renderToolTip={() => <p>Select Layers</p>}
      >
        <Icon iconName="layers" />
      </Button>
      <DialogModal
        shouldCloseOnOverlayClick
        isOpen={showOverlays}
        closeModal={() => setShowOverlays(!showOverlays)}
      >
        <div className="map-controls__overlays-modal-wrapper">
          <Heading
            headingCopy="Layers"
            bodyCopy="Select one or multiple layers to display on the map and a base map tile option."
          />
          <div className="map-controls__overlays-base-style-btn-wrapper">
            <Button
              className="map-controls__overlays-base-style-btn"
              disabled={!satActive}
              active={!satActive}
              handleClick={setMapStyle}
              name={defaultStyle}
            >
              Streets
            </Button>
            <Button
              className="map-controls__overlays-base-style-btn"
              disabled={satActive}
              active={satActive}
              handleClick={setMapStyle}
              name={satelliteStyle}
            >
              Satellite
            </Button>
          </div>
          {hasOverlays && (
            <ul className="map-controls__overlays-toggle-list">
              {renderOverlayOptions()}
            </ul>
          )}
          <p>
            Upload a new layer in the{' '}
            <a
              href={`${process.env.REACT_APP_CMS_URL}/?id=${config.map}`}
              target="_blank"
              rel="noreferrer noopener"
            >
              {' '}
              CMS{' '}
            </a>
          </p>
        </div>
      </DialogModal>
    </div>
  );
};

export default Overlays;
